export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-20 border-t border-matrix-green/15 bg-matrix-ink/60 px-6 py-12 sm:px-10 lg:px-16"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
        <div>
          <span className="font-display text-2xl font-black uppercase tracking-tighter brand-glow">
            Doriantelive
          </span>
          <p className="mt-2 font-mono text-xs text-white/40">
            &copy; 2026 Doriantelive — All Rights Reserved. Web design began 2026-05-09.
          </p>
        </div>
        <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-matrix-green">
          <span className="inline-block h-2 w-2 rounded-full bg-matrix-green animate-glow-pulse" />
          system online
        </div>
      </div>
    </footer>
  );
};
